import { CoreRoutingModule } from '@analytics/core/core-routing.module';
import { AnalyticsSharedModule } from '@analytics/shared/shared.module';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { environment } from '@environment/environment';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InterceptorService } from '@shared/services/interceptor.service';
import { CustomPreloadingStrategy } from '@shared/strategies/custom.preloading.strategy';
import { HIGHCHARTS_MODULES } from 'angular-highcharts';
import * as more from 'highcharts/highcharts-more.src';
import * as drilldown from 'highcharts/modules/drilldown.src';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { provideNgxMask } from 'ngx-mask';
import { FacebookPixelModule } from '@shared/modules/facebook-pixel.module';
import { ToastrModule } from 'ngx-toastr';
import { NgxWebstorageModule } from 'ngx-webstorage';

export const createTranslateLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

@NgModule({ exports: [RouterModule, AnalyticsSharedModule],
    declarations: [], imports: [AnalyticsSharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        CoreRoutingModule,
        NgIdleKeepaliveModule.forRoot(),
        FacebookPixelModule.forRoot({
            enabled: environment.FB_PIXEL.IS_ENABLED,
            pixelId: environment.FB_PIXEL.PIXEL_ID
        }),
        BsDatepickerModule.forRoot(),
        NgxWebstorageModule.forRoot({
            prefix: 'analytics.vitay.io'
        }),
        LoggerModule.forRoot({
            // serverLoggingUrl: '/logs',
            level: environment.IS_PRODUCTION
                ? NgxLoggerLevel.ERROR
                : NgxLoggerLevel.DEBUG
            // serverLogLevel: NgxLoggerLevel.ERROR
        }),
        ToastrModule.forRoot({
            timeOut: 2000,
            toastClass: 'ngx-toastr v-toastr',
            preventDuplicates: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        })], providers: [
        CustomPreloadingStrategy,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        {
            provide: HIGHCHARTS_MODULES,
            useFactory: () => [more, drilldown]
        },
        provideNgxMask(),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule {}
